import axios from 'axios';

import { axiosForHybris } from '../axios/axiosForHybris';
import { datadogLogger } from '../datadog/datadogLogger';
import { DDComponent } from '../datadog/setup';
import { API } from './constants';
import { UserDataResponse } from './model';

export const apiGetUserData = () => axiosForHybris.get<UserDataResponse>(API.USER_DATA, { withCredentials: true });

export const apiProlongAuthSession = () =>
    axiosForHybris.get(API.URL_AUTH_SESSION_PROLONGATION, { withCredentials: true });

export const redirectToLogout = () => (window.location.href = API.LOG_OUT);

export const reloadPage = () => window.location.assign(window.location.href.split('#')[0]);

export const sessionPing = async () => {
    try {
        await apiProlongAuthSession();
    } catch (error) {
        if (axios.isAxiosError(error) && error.response?.status === 403) {
            return reloadPage();
        }
        const datadogLogs = datadogLogger();
        datadogLogs.error('Session ping failed', { error, component: DDComponent.SSO });
    }
};
